/* GreenVertus — sommaire d'article généré côté client.
   Ne modifie jamais le texte de l'article : le script repère les H2
   existants, leur ajoute une ancre, construit une liste de liens et
   déplace (sans le réécrire) le contenu dans une grille.
   En cas d'échec on sort sans rien toucher.
   27/09/2026 : garde anti-double exécution. Le même code est aussi exécuté
   en ligne juste après l'article (snippet gv-article-toc-inline) pour que la
   mise en page soit faite AVANT le premier affichage (évite le décalage CLS). */
(function () {
  'use strict';

  var MIN_HEADINGS = 3;
  var DESKTOP = '(min-width: 1024px)';

  function slug(txt) {
    return txt
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
  }

  function init() {
    if (window.__gvTocDone) return;
    window.__gvTocDone = true;

    var main = document.querySelector('#MainContent') || document.querySelector('main');
    if (!main) return;

    var all = main.querySelectorAll('h2');
    if (!all.length) return;

    var content = all[0].parentElement;
    if (!content) return;

    var headings = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].parentElement === content && all[i].textContent.trim()) headings.push(all[i]);
    }
    if (headings.length < MIN_HEADINGS) return;

    document.body.classList.add('gv-article-page');

    var used = {};
    headings.forEach(function (h, idx) {
      if (!h.id) {
        var base = slug(h.textContent) || 'section';
        var id = base, n = idx;
        while (used[id] || document.getElementById(id)) { id = base + '-' + ++n; }
        h.id = id;
      }
      used[h.id] = true;
    });

    var details = document.createElement('details');
    details.className = 'gv-toc';

    var summary = document.createElement('summary');
    summary.textContent = 'Table des matières';
    details.appendChild(summary);

    var scroll = document.createElement('nav');
    scroll.className = 'gv-toc-scroll';
    scroll.setAttribute('aria-label', 'Sommaire de l article');

    var ol = document.createElement('ol');
    var links = [];
    headings.forEach(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      ol.appendChild(li);
      links.push(a);
    });
    scroll.appendChild(ol);
    details.appendChild(scroll);

    var layout = document.createElement('div');
    layout.className = 'gv-toc-layout';
    var card = document.createElement('div');
    card.className = 'gv-article-card';

    content.parentNode.insertBefore(layout, content);
    layout.appendChild(details);
    layout.appendChild(card);
    card.appendChild(content);

    /* Neutralise le calque blanc du thème sur cette section uniquement */
    var sec = layout.closest ? layout.closest('.shopify-section') : null;
    if (sec) sec.classList.add('gv-article-section');

    /* Rapatrie titre / date / image au-dessus du contenu, dans la carte */
    var block = layout.closest ? layout.closest('.shopify-block') : null;
    if (block) {
      var head = document.createElement('div');
      head.className = 'gv-article-head';
      var sibs = [], s = block.previousElementSibling;
      while (s) { sibs.unshift(s); s = s.previousElementSibling; }
      sibs.forEach(function (n) { head.appendChild(n); });
      if (sibs.length) card.insertBefore(head, card.firstChild);
    }

    var mq = window.matchMedia(DESKTOP);
    function syncOpen() { details.open = mq.matches; }
    syncOpen();
    if (mq.addEventListener) mq.addEventListener('change', syncOpen);
    else if (mq.addListener) mq.addListener(syncOpen);

    scroll.addEventListener('click', function (e) {
      if (e.target.tagName === 'A' && !mq.matches) details.open = false;
    });

    if (!('IntersectionObserver' in window)) return;

    var current = null;
    function setActive(a) {
      if (current === a) return;
      if (current) current.classList.remove('is-active');
      if (a) a.classList.add('is-active');
      current = a;
      if (a && mq.matches && scroll.scrollHeight > scroll.clientHeight) {
        scroll.scrollTo({ top: a.offsetTop - scroll.clientHeight / 2, behavior: 'smooth' });
      }
    }

    var visible = [];
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var i = visible.indexOf(entry.target);
        if (entry.isIntersecting) { if (i === -1) visible.push(entry.target); }
        else if (i !== -1) { visible.splice(i, 1); }
      });
      for (var k = 0; k < headings.length; k++) {
        if (visible.indexOf(headings[k]) !== -1) { setActive(links[k]); return; }
      }
    }, { rootMargin: '-15% 0px -70% 0px', threshold: 0 });

    headings.forEach(function (h) { observer.observe(h); });
  }

  window.gvArticleTocInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();